import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { FhtLeancloudCustomMessageType } from "@/common/types";
import RichCustomChatMessageDto from "@/models/messages/RichCustomChatMessageDto";
import { TypedMessage } from "leancloud-realtime";
import { assert } from "@/common/assert";
import { getDeviceType } from "../messageConvertUtils";
import { MessageIOType } from "@/models/MessageTypes";

var FhtCustomMessage =
/** @class */
function (_super) {
  __extends(FhtCustomMessage, _super);

  function FhtCustomMessage(customAttrs) {
    var _this = _super.call(this, undefined) || this;

    _this.customAttrs = customAttrs;
    assert(customAttrs, "customAttrs falsy");

    _this.setAttributes(customAttrs);

    return _this;
  }

  FhtCustomMessage.prototype.convertToChatMessage = function (myself) {
    assert(myself, "myself falsy");
    assert(myself.clientId, "myself.clientId falsy");
    var deviceType = getDeviceType(this);
    var ioType = this.from === myself.clientId ? MessageIOType.Sent : MessageIOType.Received;
    var msgtype = this.type;
    assert(FhtLeancloudCustomMessageType[msgtype], "not fht custom message type");
    return new RichCustomChatMessageDto(this.id, ioType, deviceType, this.timestamp, msgtype, this.customAttrs, myself);
  };

  return FhtCustomMessage;
}(TypedMessage);

export { FhtCustomMessage };